import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {take} from "rxjs/operators";
import {
  BASK_BRAND_NAME, TCB_BRAND_NAME,
  SUCCESS_MESSAGE_ACCOUNT_PLURAL_INDICATOR,
  SUCCESS_MESSAGE_ACCOUNT_PLURAL_PLACEHOLDER,
  SUCCESS_MESSAGE_ACCOUNT_TYPE_PLACEHOLDER, INVITATION_CREATION_PATH} from "../shared/constants";
import {SettingsEnum} from '../shared/model/settings.enum';
import {SuccessConfiguration} from "../shared/model/success-configuration";
import {FacadeService} from "../shared/service-facade/facade.service";
import {MainLayoutService} from '../shared/services/main-layout.service';
import {OnboardingSuccessfulResponse} from "../shared/services/onboarding.service";
import {Sections, SectionStates} from '../status-tracker/model/section-status';
import {SectionStatusService} from '../status-tracker/section-status.service';
import {ApplicationLogsRequest} from 'leia-api';
import {BrandType} from "../signup/models/brand-type";
import {CoreService} from "../shared/services/core.service";
import {SignupService} from '../signup/service/signup.service';
import {AtomicService} from "../shared/services/atomic.service";
import {ErrorDialogService} from "../shared/services/error-dialog.service";

//const mParticle = require("@mparticle/web-sdk");

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {
  successMessage = '';
  accounts: string[] = [];
  credentialsCreatedSuccessfully = true;
  title = '';
  accountType = '';
  newAccountMessage = '';
  newJointAccountMessage = '';
  nextSteps = '';
  howToContact = '';
  username = '';
  customerSupportPhone = '';
  loginUrl = '';
  isEnrolledInOLB = false;
  hideLogin = false;
  isBankingCenter = false;
  isMinor = false;
  createCredentialsURL = "";
  isInJointMaintenanceFlow = false;
  isInAuthenticatedFlow = false;
  isAuthenticatedFlowResume = false;
  isExistingCustomer = false;
  showAuthenticatedAddJointArea = false;
  isJointOwnerFeatureEnabled = false;
  jointOwnerFeatureDisabledText = "";
  multipleProductsAccount : MultipleProductsAccount[] = [];
  productsWithAccounts: MultipleProductsAccount[] = [];
  productsWithoutAccounts: MultipleProductsAccount[] = [];
  showDirectDepositArea = false;
  directDepositText = "";
  isBaskBrand: boolean = false;

  constructor(
    private _domSanitazer: DomSanitizer,
    private facade: FacadeService,
    public mainLayout: MainLayoutService,
    private appStateService: SectionStatusService,
    private coreService: CoreService,
    private signupService: SignupService,
    private atomicService : AtomicService,
    private errorDialogService: ErrorDialogService
  ) {
  }

  ngOnInit(): void {

    this.coreService.disableBackButton();

    this.isInAuthenticatedFlow = this.facade.isInAuthenticatedFlow$.getValue()[0];

    this.isAuthenticatedFlowResume = this.facade.isInAuthenticatedFlow$.getValue()[1];

    this.isInJointMaintenanceFlow = this.facade.isInJointMaintenanceFlow();

    this.isMinor = this.facade.getIsMinor();

    this.isBankingCenter = this.facade.isFromBranch();

    this.appStateService.updateStatusTrackerSectionStatus(Sections.VerifyIdentification, SectionStates.complete);
    this.appStateService.updateStatusTrackerSectionStatus(Sections.CreateLogin, SectionStates.complete);

    this.facade.showSuccessTracker();
    this._setupCredentialCreationLink();

    this.isBaskBrand = this.facade.isBaskBrand();

    if (this.isBankingCenter) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
    }

    // if the feature flag is toggled to false, this setting will hide the joint
    // owner button and display static text in its place
    this.isJointOwnerFeatureEnabled = this.facade.getStorageItemAsBoolean(SettingsEnum.EnableJointOwnerAuthenticatedFlow);

    // if the feature is disabled, populate the disabled text from the settings
    if (!this.isJointOwnerFeatureEnabled) {
      this.jointOwnerFeatureDisabledText = this.facade.getStorageItem(SettingsEnum.AuthenticatedFlowJointOwnerFeatureDisabledText);
    }

    // this.showDirectDepositArea = true;
    this.showDirectDepositArea = this.atomicService.isAtomicAvailable();

    if (this.showDirectDepositArea)
      this.directDepositText = this.facade.getStorageItem(SettingsEnum.DirectDepositFeatureText);

    this.showAuthenticatedAddJointArea = this.isInAuthenticatedFlow
      && this.facade.allowJointApplications$.getValue() && !this.isAuthenticatedFlowResume;

    this.facade.globalSettingsLoaded.pipe(
      take(1)
    ).subscribe(settings => {
      this.populateLocalProperties(
        this.facade.getNewAccountInformation(),
        this.facade.getSuccessConfiguration(),
        this.facade.getShoppingCartApplicationLogsRequest()
      );
    });

    /*
    const multipleProductsAccount: MultipleProductsAccount[] = [
      {
        productName: "Test",
        productDescription: "Some description",
        productType: "sav",
        accountNumber: "12345678",
        accountAPYText: "Some APY bla bla bla bla bla bla bla bla bla bla",
        status: true
      },
      {
        productName: "Test",
        productDescription: "Some description",
        productType: "mma",
        accountNumber: "12345678",
        accountAPYText: "Some APY",
        status: true
      },
      {
        productName: "Test",
        productDescription: "Some description",
        productType: "cod",
        accountNumber: "12345678",
        accountAPYText: "Some APY bla bla bla bla bla bla bla bla bla bla",
        status: true
      },
      {
        productName: "Test",
        productDescription: "Some description",
        productType: "dda",
        accountNumber: "12345678",
        accountAPYText: "Some APY",
        status: true
      },
    ];
    */

    this.multipleProductsAccount = this.signupService.multipleProductsAccount;
    this.productsWithAccounts = this.multipleProductsAccount.filter((product) => product.accountNumber);
    this.productsWithoutAccounts = this.multipleProductsAccount.filter((product) => !product.accountNumber);
    if(this.productsWithoutAccounts.length > 0) {
      this.successMessage = `${this.productsWithoutAccounts.length} of ${this.signupService.multipleProductsAccount.length} accounts were opened`;
    } else {
      this.productsWithAccounts = this.multipleProductsAccount;
    }

    //comment mParticle, CDP scripts are live, remove the code later
    // mParticle.default.logPageView(
    //   "Step 5 - Approved",
    //   {page: window.location.toString()}
    // );

    this.mainLayout.setPageTitle(`Congratulations!`);

    this.atomicService.atomicErrorOccurredEvent.subscribe(next => {
      this.errorDialogService.openDialog('Direct Deposit failure has occurred.', 0);
    });
  }

  private _setupCredentialCreationLink(): void {
    this.createCredentialsURL = this.facade.getStorageItem(SettingsEnum.CreateCredentialsURL);
  }


  private populateLocalProperties(accountInfo: OnboardingSuccessfulResponse, successConfiguration: SuccessConfiguration, applicationRequest: ApplicationLogsRequest) {
    const {accountType, accountNumber, username, isEnrolledOLB, olbCredentialCreationSuccessfull} = accountInfo;
    const {
      cancelUrl, customerSupportPhone, howToContact,
      loginUrl, nextSteps, title, newAccountMessage, newJointAccountMessage
    } = successConfiguration;

    applicationRequest.applicants?.forEach(applicant => {
      const {isExistingCustomer} = applicant;
      this.isExistingCustomer = isExistingCustomer!;
    })

    this.credentialsCreatedSuccessfully = !!olbCredentialCreationSuccessfull;
    this.accountType = accountType;
    this.accounts = accountNumber.split(",");
    this.username = username;
    this.customerSupportPhone = customerSupportPhone;
    this.howToContact = howToContact;
    this.loginUrl = loginUrl;
    this.nextSteps = nextSteps;
    this.title = title;
    this.isEnrolledInOLB = isEnrolledOLB;

    if (!this.isEnrolledInOLB && !this.credentialsCreatedSuccessfully || this.isMinor || this.isBankingCenter || this.isInAuthenticatedFlow) {
      this.hideLogin = true;
    }

    this.mainLayout.showAppStoreBanner();

    if (this.isInJointMaintenanceFlow) {
      let pluralIndicator = "";
      let brandName = "";
      if (this.accounts.length > 1) {
        pluralIndicator = SUCCESS_MESSAGE_ACCOUNT_PLURAL_INDICATOR;
        brandName = (+this.facade.getBrandId() === BrandType.BaskBank) ? BASK_BRAND_NAME : TCB_BRAND_NAME;
      }

      this.successMessage = newJointAccountMessage.replace(
        SUCCESS_MESSAGE_ACCOUNT_TYPE_PLACEHOLDER,
        (this.accounts.length > 1) ? brandName : accountType
      );

      this.successMessage = this.successMessage.replace(
        SUCCESS_MESSAGE_ACCOUNT_PLURAL_PLACEHOLDER,
        pluralIndicator
      );
    } else {
      this.successMessage = newAccountMessage.replace(
        SUCCESS_MESSAGE_ACCOUNT_TYPE_PLACEHOLDER,
        accountType
      );


    }
  }

  navigateTo(url: string): void {
    this.appStateService.updateStatusTrackerSectionStatus(Sections.VerifyIdentification, SectionStates.complete);

    window.location.href = url;
  }

  proceedToAddJoint() {
    this.coreService.navigate(`/${INVITATION_CREATION_PATH}`);
    this.signupService.clearFormStateObservables();
    window.scrollTo(0, 0);
  }

  getEffectiveDate() {
    return SignupService.getEffectiveDate();
  }

  launchAtomicSdk() {
    this.atomicService.launchAtomicSdk(this.facade.getSessionId());
  }
}
export interface MultipleProductsAccount {
  productName: string;
  productDescription: string;
  productType: string;
  accountAPYText?: string;
  accountNumber: string;
  status?: boolean;
  productStripeColor?: string;
}
